import React from 'react';
import PropTypes from 'prop-types';
import { MarkdownWrapper } from 'components/atoms';
import { pageTypes } from 'config/pageTypes';
import {
	FeaturedContentSection,
	PSPLinks,
	PSPHero,
	PSPReviewSection,
	StorageNearYou,
	ContentSection,
	FAQSection,
	CTABlock,
	CardStrip,
	SizeComparisonSection,
	PSPVideo,
	LockerComparison,
} from '../../organisms';
import { SizeGuideHero } from '../../organisms/SizeGuideHero';
import { SGPHeader } from 'components/molecules';

export const PSPPageSectionsMap = {
	markdownSection: MarkdownWrapper,
	hero: PSPHero,
	reviews: PSPReviewSection,
	links: PSPLinks,
	featuredContent: FeaturedContentSection,
	faqs: FAQSection,
	inlineCTA: CTABlock,
	storageNearYou: StorageNearYou,
	content: ContentSection,
	cardStrip: CardStrip,
	sizeComparisonSection: SizeComparisonSection,
	video: PSPVideo,
	sizeGuideHero: SizeGuideHero,
	sgpHeader: SGPHeader,
	lockerComparison: LockerComparison,
};

function PSPModuleFactory({ type, props, children, pageType }) {
	if (type in PSPPageSectionsMap) {
		return React.createElement(
			PSPPageSectionsMap[type],
			{ ...props, pageType },
			children,
		);
	}
	return null;
}

PSPModuleFactory.propTypes = {
	children: PropTypes.node,
	props: PropTypes.object,
	type: PropTypes.string,
	pageType: PropTypes.oneOf([pageTypes.PSP, pageTypes.SGP]),
};

export default PSPModuleFactory;
